import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { FC, useEffect, useState } from 'react';

/** Long enough that a cached query or a warm chunk never flashes a spinner. */
const SPINNER_DELAY_MS = 1000;

/**
 * Centred page spinner, held back briefly so quick loads show nothing at all.
 *
 * The label sits on the container, not the spinner, so the region is announced for the whole
 * wait rather than only after the delay.
 */
export const PageLoading: FC = () => {
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowSpinner(true), SPINNER_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box
      role="status"
      aria-label="Loading"
      display="flex"
      flex="1"
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="100%"
      paddingY={4}
    >
      {showSpinner && <CircularProgress />}
    </Box>
  );
};
